import { render, staticRenderFns } from "./RuralLaw.vue?vue&type=template&id=4b18144a&scoped=true"
import script from "./RuralLaw.vue?vue&type=script&lang=js"
export * from "./RuralLaw.vue?vue&type=script&lang=js"
import style0 from "./RuralLaw.vue?vue&type=style&index=0&id=4b18144a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b18144a",
  null
  
)

export default component.exports